import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import GetFetch from "../hooks/GetFetch";
import PutPostPatchFetch from "../hooks/PutPostPatchFetch";
import { 
    ROUTE_REGIONAL_SETTINGS, 
    ROUTE_REGIONAL_SETTINGS_UPDATE, 
    ROUTE_WELCOME 
} from "../routes/Routes";
import DataGrid, {
    Column,
    Editing,
    Item,
    KeyboardNavigation,
    MasterDetail,
    Pager,
    RangeRule,
    RequiredRule,
    SearchPanel,
    Toolbar
} from 'devextreme-react/data-grid';
import CustomPreparedHeaderCell from "../components/CustomPreparedHeaderCell";
import usePageTitle from "../hooks/usePageTitle";
import { allowedPageSizes } from "../components/GlobalDataGridConfigurations";
import { RowExpander } from "../components/RowExpander/RowExpander";
import { Button, Toast } from "devextreme-react";


const InflationAdjustment = () => {
    const { title } = ROUTE_REGIONAL_SETTINGS;
    usePageTitle(title);
    const navigate = useNavigate();
    const navigateToHomePage = () => navigate(ROUTE_WELCOME.withSlash);
    const [tableData, setTableData] = useState([]);
    const [notification, setNotification] = useState({
    message: '',
    type: undefined,
    visible: false});

    useEffect(() => {
        getRecords();
    }, []);

    const getRecords = async () => {
        const { Errors, Message, Success } = await GetFetch('/v1/Region/GetSettingsAllRegions');
        
        if (Success) { 
            const regionData = Message.map(item =>  ({...item, RegionalSettings: {...item.RegionalSettings[0], RegionNumber: item.RegionNumber, InflationRate: item.RegionalSettings[0].InflationRate}}));
            setTableData(regionData);
        };
        if (Errors.length > 0) console.error(Errors);
    };

    const onHomeClick = () => {
        navigateToHomePage();
    };
    
    const renderCellEditLabel = ({ data }) => {
        return (
            <a href={ROUTE_REGIONAL_SETTINGS_UPDATE.withSlash + '?regionNumber=' + data.RegionNumber}
                onClick={() => {
                        const dataGrid = data.component;
                        //let dComponent = e.component;
                        dataGrid.editRow(data.RegionNumber);
/*                     navigate(ROUTE_REGIONAL_SETTINGS_UPDATE.withSlash, {
                        state: data
                    }); */
                }}
            >
                { 'Edit Region ' + data.RegionNumber }
            </a>
        );
    };

    const handleFormSubmission = async (e) => {
    /* if (!validateChanges(e.changes)) {
            e.cancel = true; // Prevent saving if validation fails
            return;
        } */
        console.log("Saving");
        const { Errors, Success } = await PutPostPatchFetch(
            "/v1/Region/UpdateSettingsByRegion",
            "POST",
            {
                RegionNumber: e.oldData.RegionNumber,
                inflationRate: e.newData.InflationRate,   
            }
        );

        if (Success) {
            setNotification({
                isVisible: true,
                message: `Region ${e.oldData.RegionNumber} was updated, successfully.`,
                type: 'success'
            });
            getRecords();
        };

        if (Errors.length > 0) {
            setNotification({
                isVisible: true,
                message: `Region ${e.oldData.RegionNumber} was not successfully updated.\nReason: ${Errors[0]}`,
                type: 'error'
            });
        };
    };

    const MasterDetailComponent = ({ data }) => {
        return (
            <>
                <DataGrid 
                    columnAutoWidth={true}
                    dataSource={[ data.data.RegionalSettings ]}
                    keyExpr='RegionNumber'
                    onCellPrepared={CustomPreparedHeaderCell}
                    // onRowClick={(e) => console.log(e)}
                    onRowUpdating={handleFormSubmission}
                    rowAlternationEnabled={true}
                    showBorders={true}
                    showColumnLines={true}
                    showRowLines={true}>
                    <Editing
                        mode="row"
                        allowAdding={false}
                        allowDeleting={false}
                        allowUpdating={true}
                    />
                    <KeyboardNavigation enabled={true} />
                    <Pager
                        allowedPageSizes={allowedPageSizes}
                        showPageSizeSelector={true}
                    />
                    <Column
                        type="buttons">
                        <Button name="edit" />
                    </Column>
                    <Column 
                        caption='Id'
                        dataField='Id'
                        visible={false}
                    />
                    <Column 
                        alignment="left"
                        caption='Region'
                        dataField='RegionNumber'
                        allowEditing={false}
                    />
                    <Column 
                        caption='Inflation Rate'
                        dataField='InflationRate'
                        // dataType="number"
                        // format={'0.0%'}
                        calculateCellValue={({ InflationRate }) => { return Math.round(InflationRate * 10) / 10 }}>
                        <RequiredRule message="Inflation Rate is required." />
                        <RangeRule message="Inflation Rate must be between 8 - 15%." min={8.0} max={15.0} reevaluate={true} />
                    </Column>
                    <Column 
                        caption='Created By'
                        dataField='CreatedBy'
                        allowEditing={false}                        
                    />
                    <Column 
                        caption='Created Date'
                        dataField='CreatedDate'
                        dataType='date'
                        allowEditing={false}                        
                    />
                    <Column 
                        caption='Updated By'
                        dataField='UpdatedBy'
                        allowEditing={false}                        
                    />
                    <Column 
                        caption='Updated Date'
                        dataField='UpdatedDate'
                        dataType='date'
                        allowEditing={false}                        
                    />
                </DataGrid>
            </>
        );
    };

    return (
        <>
            <h1> { title } </h1>
{/*             <div style={{ marginBottom: '2rem'}}>
                <Button
                    elementAttr={
                        {
                            class: 'back-button',
                            id: 'back-button'
                        }
                    }
                    onClick={() => navigate(ROUTE_WELCOME.withSlash)}
                    stylingMode='outlined'
                    text='Back'
                    type='default'
                />
            </div> */}
            {
                tableData && tableData.length > 0 ?
                <DataGrid
                    columnAutoWidth={true}
                    dataSource={tableData}
                    onCellPrepared={CustomPreparedHeaderCell}
                    rowAlternationEnabled={true}
                    showBorders={true}
                    showColumnLines={true}
                    showRowLines={true}>
                    <KeyboardNavigation
                        enabled={true}
                    />
                    <SearchPanel
                        visible={true}
                        highlightCaseSensitive={true}
                    />
                    <Toolbar>
                        <Item
                            name="searchPanel"
                            locateInMenu="auto"
                        />
                        <Item location='after'>
                            <Button text='Home' icon='home' stylingMode='outlined' type='normal' onClick={onHomeClick} />
                        </Item>
                    </Toolbar>
                    <Column
                        type='detailExpand'
                        cellRender={(data) => RowExpander(data,"Name")}
                    />
                    <Column 
                        alignment="left"
                        caption='Region'
                        dataField='RegionNumber'
                    />
                    <Column 
                        caption='Zone'
                        dataField='Zone'
                        dataType='date'
                    />
                    <Column
                        alignment="left"
                        caption='Office Location'
                        dataField='OfficeLocation'
                    />
                    <Column
                        caption='Area Of Responsibility'
                        dataField='AreaOfResponsibility'
                    />
                    <MasterDetail 
                        enabled={true}
                        component={MasterDetailComponent}
                    />
                </DataGrid>
                :
                <div>Loading data. Please wait...</div>
            }
            <Toast
                animation={{
                    show: {
                        type: 'fade',
                        duration: 300,
                        from: 0,
                        to: 1
                    },
                    hide: {
                        type: 'fade',
                        duration: 300,
                        from: 1,
                        to: 0
                    }
                }}
                closeOnClick={true}
                displayTime={0}
                focusStateEnabled={true}
                message={notification.message}
                type={notification.type}
                visible={notification.visible}
            />
        </>
    );
};

export default InflationAdjustment;